// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-l_hf","advertDetailHeaderLocation__value":"c-l_hg"};